import { gql } from '@apollo/client'
import { useQuery } from '@apollo/client'

const GET_COMMENT = gql`
  query Comment($entityId: [String]!) {
    comment(entityId: $entityId) {
      items {
        id
        comment
      }
    }
  }`

/**
 * Comment
 * @param options
 */
export function useCommentQuery (options) {
  return useQuery(GET_COMMENT, options)
}
